// src/components/PaymentHistory.js
import React from "react";

const PaymentHistory = () => {
  return (
    <div style={{ padding: 20, textAlign: "center", height: '70vh'}}>
      <h2>Payment History</h2>
      <strong style={{ fontSize: "1.1rem", color: "#000",  }}>
        Coming soon! Stay tuned for updates.
      </strong>
    </div>
  );
};

export default PaymentHistory;
